export const globalizationData = {
  main: {
    en: {
      identity: {
        version: {
          _number: "$Revision: 14491 $",
          _cldrVersion: "34"
        },
        language: "en"
      },
      dates: {
        calendars: {
          gregorian: {
            months: {
              format: {
                abbreviated: {
                  "1": "Jan",
                  "2": "Feb",
                  "3": "Mar",
                  "4": "Apr",
                  "5": "May",
                  "6": "Jun",
                  "7": "Jul",
                  "8": "Aug",
                  "9": "Sep",
                  "10": "Oct",
                  "11": "Nov",
                  "12": "Dec"
                },
                narrow: {
                  "1": "J",
                  "2": "F",
                  "3": "M",
                  "4": "A",
                  "5": "M",
                  "6": "J",
                  "7": "J",
                  "8": "A",
                  "9": "S",
                  "10": "O",
                  "11": "N",
                  "12": "D"
                },
                wide: {
                  "1": "January",
                  "2": "February",
                  "3": "March",
                  "4": "April",
                  "5": "May",
                  "6": "June",
                  "7": "July",
                  "8": "August",
                  "9": "September",
                  "10": "October",
                  "11": "November",
                  "12": "December"
                }
              },
              "stand-alone": {
                abbreviated: {
                  "1": "Jan",
                  "2": "Feb",
                  "3": "Mar",
                  "4": "Apr",
                  "5": "May",
                  "6": "Jun",
                  "7": "Jul",
                  "8": "Aug",
                  "9": "Sep",
                  "10": "Oct",
                  "11": "Nov",
                  "12": "Dec"
                },
                narrow: {
                  "1": "J",
                  "2": "F",
                  "3": "M",
                  "4": "A",
                  "5": "M",
                  "6": "J",
                  "7": "J",
                  "8": "A",
                  "9": "S",
                  "10": "O",
                  "11": "N",
                  "12": "D"
                },
                wide: {
                  "1": "January",
                  "2": "February",
                  "3": "March",
                  "4": "April",
                  "5": "May",
                  "6": "June",
                  "7": "July",
                  "8": "August",
                  "9": "September",
                  "10": "October",
                  "11": "November",
                  "12": "December"
                }
              }
            },
            days: {
              format: {
                abbreviated: {
                  sun: "Sun",
                  mon: "Mon",
                  tue: "Tue",
                  wed: "Wed",
                  thu: "Thu",
                  fri: "Fri",
                  sat: "Sat"
                },
                narrow: {
                  sun: "S",
                  mon: "M",
                  tue: "T",
                  wed: "W",
                  thu: "T",
                  fri: "F",
                  sat: "S"
                },
                short: {
                  sun: "Su",
                  mon: "Mo",
                  tue: "Tu",
                  wed: "We",
                  thu: "Th",
                  fri: "Fr",
                  sat: "Sa"
                },
                wide: {
                  sun: "Sunday",
                  mon: "Monday",
                  tue: "Tuesday",
                  wed: "Wednesday",
                  thu: "Thursday",
                  fri: "Friday",
                  sat: "Saturday"
                }
              },
              "stand-alone": {
                abbreviated: {
                  sun: "Sun",
                  mon: "Mon",
                  tue: "Tue",
                  wed: "Wed",
                  thu: "Thu",
                  fri: "Fri",
                  sat: "Sat"
                },
                narrow: {
                  sun: "S",
                  mon: "M",
                  tue: "T",
                  wed: "W",
                  thu: "T",
                  fri: "F",
                  sat: "S"
                },
                short: {
                  sun: "Su",
                  mon: "Mo",
                  tue: "Tu",
                  wed: "We",
                  thu: "Th",
                  fri: "Fr",
                  sat: "Sa"
                },
                wide: {
                  sun: "Sunday",
                  mon: "Monday",
                  tue: "Tuesday",
                  wed: "Wednesday",
                  thu: "Thursday",
                  fri: "Friday",
                  sat: "Saturday"
                }
              }
            },
            quarters: {
              format: {
                abbreviated: {
                  "1": "Q1",
                  "2": "Q2",
                  "3": "Q3",
                  "4": "Q4"
                },
                narrow: {
                  "1": "1",
                  "2": "2",
                  "3": "3",
                  "4": "4"
                },
                wide: {
                  "1": "1st quarter",
                  "2": "2nd quarter",
                  "3": "3rd quarter",
                  "4": "4th quarter"
                }
              },
              "stand-alone": {
                abbreviated: {
                  "1": "Q1",
                  "2": "Q2",
                  "3": "Q3",
                  "4": "Q4"
                },
                narrow: {
                  "1": "1",
                  "2": "2",
                  "3": "3",
                  "4": "4"
                },
                wide: {
                  "1": "1st quarter",
                  "2": "2nd quarter",
                  "3": "3rd quarter",
                  "4": "4th quarter"
                }
              }
            },
            dayPeriods: {
              format: {
                abbreviated: {
                  midnight: "midnight",
                  am: "AM",
                  "am-alt-variant": "am",
                  noon: "noon",
                  pm: "PM",
                  "pm-alt-variant": "pm",
                  morning1: "in the morning",
                  afternoon1: "in the afternoon",
                  evening1: "in the evening",
                  night1: "at night"
                },
                narrow: {
                  midnight: "mi",
                  am: "a",
                  "am-alt-variant": "am",
                  noon: "n",
                  pm: "p",
                  "pm-alt-variant": "pm",
                  morning1: "in the morning",
                  afternoon1: "in the afternoon",
                  evening1: "in the evening",
                  night1: "at night"
                },
                wide: {
                  midnight: "midnight",
                  am: "AM",
                  "am-alt-variant": "am",
                  noon: "noon",
                  pm: "PM",
                  "pm-alt-variant": "pm",
                  morning1: "in the morning",
                  afternoon1: "in the afternoon",
                  evening1: "in the evening",
                  night1: "at night"
                }
              },
              "stand-alone": {
                abbreviated: {
                  midnight: "midnight",
                  am: "AM",
                  "am-alt-variant": "am",
                  noon: "noon",
                  pm: "PM",
                  "pm-alt-variant": "pm",
                  morning1: "morning",
                  afternoon1: "afternoon",
                  evening1: "evening",
                  night1: "night"
                },
                narrow: {
                  midnight: "midnight",
                  am: "AM",
                  "am-alt-variant": "am",
                  noon: "noon",
                  pm: "PM",
                  "pm-alt-variant": "pm",
                  morning1: "morning",
                  afternoon1: "afternoon",
                  evening1: "evening",
                  night1: "night"
                },
                wide: {
                  midnight: "midnight",
                  am: "AM",
                  "am-alt-variant": "am",
                  noon: "noon",
                  pm: "PM",
                  "pm-alt-variant": "pm",
                  morning1: "morning",
                  afternoon1: "afternoon",
                  evening1: "evening",
                  night1: "night"
                }
              }
            },
            eras: {
              eraNames: {
                "0": "Before Christ",
                "0-alt-variant": "Before Common Era",
                "1": "Anno Domini",
                "1-alt-variant": "Common Era"
              },
              eraAbbr: {
                "0": "BC",
                "0-alt-variant": "BCE",
                "1": "AD",
                "1-alt-variant": "CE"
              },
              eraNarrow: {
                "0": "B",
                "0-alt-variant": "BCE",
                "1": "A",
                "1-alt-variant": "CE"
              }
            },
            dateFormats: {
              full: "EEEE, MMMM d, y",
              long: "MMMM d, y",
              medium: "MMM d, y",
              short: "M/d/yy"
            },
            timeFormats: {
              full: "h:mm:ss a zzzz",
              long: "h:mm:ss a z",
              medium: "h:mm:ss a",
              short: "h:mm a"
            },
            dateTimeFormats: {
              full: "{1} 'at' {0}",
              long: "{1} 'at' {0}",
              medium: "{1}, {0}",
              short: "{1}, {0}",
              availableFormats: {
                Bh: "h B",
                Bhm: "h:mm B",
                Bhms: "h:mm:ss B",
                d: "d",
                E: "ccc",
                EBhm: "E h:mm B",
                EBhms: "E h:mm:ss B",
                Ed: "d E",
                Ehm: "E h:mm a",
                EHm: "E HH:mm",
                Ehms: "E h:mm:ss a",
                EHms: "E HH:mm:ss",
                Gy: "y G",
                GyMMM: "MMM y G",
                GyMMMd: "MMM d, y G",
                GyMMMEd: "E, MMM d, y G",
                h: "h a",
                H: "HH",
                hm: "h:mm a",
                Hm: "HH:mm",
                hms: "h:mm:ss a",
                Hms: "HH:mm:ss",
                hmsv: "h:mm:ss a v",
                Hmsv: "HH:mm:ss v",
                hmv: "h:mm a v",
                Hmv: "HH:mm v",
                M: "L",
                Md: "M/d",
                MEd: "E, M/d",
                MMM: "LLL",
                MMMd: "MMM d",
                MMMEd: "E, MMM d",
                MMMMd: "MMMM d",
                "MMMMW-count-one": "'week' W 'of' MMMM",
                "MMMMW-count-other": "'week' W 'of' MMMM",
                ms: "mm:ss",
                y: "y",
                yM: "M/y",
                yMd: "M/d/y",
                yMEd: "E, M/d/y",
                yMMM: "MMM y",
                yMMMd: "MMM d, y",
                yMMMEd: "E, MMM d, y",
                yMMMM: "MMMM y",
                yQQQ: "QQQ y",
                yQQQQ: "QQQQ y",
                "yw-count-one": "'week' w 'of' Y",
                "yw-count-other": "'week' w 'of' Y"
              },
              appendItems: {
                Day: "{0} ({2}: {1})",
                "Day-Of-Week": "{0} {1}",
                Era: "{0} {1}",
                Hour: "{0} ({2}: {1})",
                Minute: "{0} ({2}: {1})",
                Month: "{0} ({2}: {1})",
                Quarter: "{0} ({2}: {1})",
                Second: "{0} ({2}: {1})",
                Timezone: "{0} {1}",
                Week: "{0} ({2}: {1})",
                Year: "{0} {1}"
              },
              intervalFormats: {
                intervalFormatFallback: "{0} – {1}",
                d: {
                  d: "d – d"
                },
                Gy: {
                  G: "y G – y G",
                  y: "y – y G"
                },
                GyM: {
                  G: "M/y GGGGG – M/y GGGGG",
                  M: "M/y – M/y GGGGG",
                  y: "M/y – M/y GGGGG"
                },
                GyMd: {
                  d: "M/d/y – M/d/y GGGGG",
                  G: "M/d/y GGGGG – M/d/y GGGGG",
                  M: "M/d/y – M/d/y GGGGG",
                  y: "M/d/y – M/d/y GGGGG"
                },
                GyMEd: {
                  d: "E, M/d/y – E, M/d/y GGGGG",
                  G: "E, M/d/y GGGGG – E, M/d/y GGGGG",
                  M: "E, M/d/y – E, M/d/y GGGGG",
                  y: "E, M/d/y – E, M/d/y GGGGG"
                },
                GyMMM: {
                  G: "MMM y G – MMM y G",
                  M: "MMM – MMM y G",
                  y: "MMM y – MMM y G"
                },
                GyMMMd: {
                  d: "MMM d – d, y G",
                  G: "MMM d, y G – MMM d, y G",
                  M: "MMM d – MMM d, y G",
                  y: "MMM d, y – MMM d, y G"
                },
                GyMMMEd: {
                  d: "E, MMM d – E, MMM d, y G",
                  G: "E, MMM d, y G – E, MMM d, y G",
                  M: "E, MMM d – E, MMM d, y G",
                  y: "E, MMM d, y – E, MMM d, y G"
                },
                h: {
                  a: "h a – h a",
                  h: "h – h a"
                },
                H: {
                  H: "HH – HH"
                },
                hm: {
                  a: "h:mm a – h:mm a",
                  h: "h:mm – h:mm a",
                  m: "h:mm – h:mm a"
                },
                Hm: {
                  H: "HH:mm – HH:mm",
                  m: "HH:mm – HH:mm"
                },
                hmv: {
                  a: "h:mm a – h:mm a v",
                  h: "h:mm – h:mm a v",
                  m: "h:mm – h:mm a v"
                },
                Hmv: {
                  H: "HH:mm – HH:mm v",
                  m: "HH:mm – HH:mm v"
                },
                hv: {
                  a: "h a – h a v",
                  h: "h – h a v"
                },
                Hv: {
                  H: "HH – HH v"
                },
                M: {
                  M: "M – M"
                },
                Md: {
                  d: "M/d – M/d",
                  M: "M/d – M/d"
                },
                MEd: {
                  d: "E, M/d – E, M/d",
                  M: "E, M/d – E, M/d"
                },
                MMM: {
                  M: "MMM – MMM"
                },
                MMMd: {
                  d: "MMM d – d",
                  M: "MMM d – MMM d"
                },
                MMMEd: {
                  d: "E, MMM d – E, MMM d",
                  M: "E, MMM d – E, MMM d"
                },
                y: {
                  y: "y – y"
                },
                yM: {
                  M: "M/y – M/y",
                  y: "M/y – M/y"
                },
                yMd: {
                  d: "M/d/y – M/d/y",
                  M: "M/d/y – M/d/y",
                  y: "M/d/y – M/d/y"
                },
                yMEd: {
                  d: "E, M/d/y – E, M/d/y",
                  M: "E, M/d/y – E, M/d/y",
                  y: "E, M/d/y – E, M/d/y"
                },
                yMMM: {
                  M: "MMM – MMM y",
                  y: "MMM y – MMM y"
                },
                yMMMd: {
                  d: "MMM d – d, y",
                  M: "MMM d – MMM d, y",
                  y: "MMM d, y – MMM d, y"
                },
                yMMMEd: {
                  d: "E, MMM d – E, MMM d, y",
                  M: "E, MMM d – E, MMM d, y",
                  y: "E, MMM d, y – E, MMM d, y"
                },
                yMMMM: {
                  M: "MMMM – MMMM y",
                  y: "MMMM y – MMMM y"
                }
              }
            }
          }
        }
      },
      numbers: {
        defaultNumberingSystem: "latn",
        otherNumberingSystems: {
          native: "latn"
        },
        minimumGroupingDigits: "1",
        "symbols-numberSystem-latn": {
          decimal: ".",
          group: ",",
          list: ";",
          percentSign: "%",
          plusSign: "+",
          minusSign: "-",
          exponential: "E",
          superscriptingExponent: "×",
          perMille: "‰",
          infinity: "∞",
          nan: "NaN",
          timeSeparator: ":"
        },
        "decimalFormats-numberSystem-latn": {
          standard: "#,##0.###",
          long: {
            decimalFormat: {
              "1000-count-one": "0 thousand",
              "1000-count-other": "0 thousand",
              "10000-count-one": "00 thousand",
              "10000-count-other": "00 thousand",
              "100000-count-one": "000 thousand",
              "100000-count-other": "000 thousand",
              "1000000-count-one": "0 million",
              "1000000-count-other": "0 million",
              "10000000-count-one": "00 million",
              "10000000-count-other": "00 million",
              "100000000-count-one": "000 million",
              "100000000-count-other": "000 million",
              "1000000000-count-one": "0 billion",
              "1000000000-count-other": "0 billion",
              "10000000000-count-one": "00 billion",
              "10000000000-count-other": "00 billion",
              "100000000000-count-one": "000 billion",
              "100000000000-count-other": "000 billion",
              "1000000000000-count-one": "0 trillion",
              "1000000000000-count-other": "0 trillion",
              "10000000000000-count-one": "00 trillion",
              "10000000000000-count-other": "00 trillion",
              "100000000000000-count-one": "000 trillion",
              "100000000000000-count-other": "000 trillion"
            }
          },
          short: {
            decimalFormat: {
              "1000-count-one": "0K",
              "1000-count-other": "0K",
              "10000-count-one": "00K",
              "10000-count-other": "00K",
              "100000-count-one": "000K",
              "100000-count-other": "000K",
              "1000000-count-one": "0M",
              "1000000-count-other": "0M",
              "10000000-count-one": "00M",
              "10000000-count-other": "00M",
              "100000000-count-one": "000M",
              "100000000-count-other": "000M",
              "1000000000-count-one": "0B",
              "1000000000-count-other": "0B",
              "10000000000-count-one": "00B",
              "10000000000-count-other": "00B",
              "100000000000-count-one": "000B",
              "100000000000-count-other": "000B",
              "1000000000000-count-one": "0T",
              "1000000000000-count-other": "0T",
              "10000000000000-count-one": "00T",
              "10000000000000-count-other": "00T",
              "100000000000000-count-one": "000T",
              "100000000000000-count-other": "000T"
            }
          }
        },
        "scientificFormats-numberSystem-latn": {
          standard: "#E0"
        },
        "percentFormats-numberSystem-latn": {
          standard: "#,##0%"
        },
        "currencyFormats-numberSystem-latn": {
          currencySpacing: {
            beforeCurrency: {
              currencyMatch: "[:^S:]",
              surroundingMatch: "[:digit:]",
              insertBetween: " "
            },
            afterCurrency: {
              currencyMatch: "[:^S:]",
              surroundingMatch: "[:digit:]",
              insertBetween: " "
            }
          },
          standard: "¤#,##0.00",
          accounting: "¤#,##0.00;(¤#,##0.00)",
          short: {
            standard: {
              "1000-count-one": "¤0K",
              "1000-count-other": "¤0K",
              "10000-count-one": "¤00K",
              "10000-count-other": "¤00K",
              "100000-count-one": "¤000K",
              "100000-count-other": "¤000K",
              "1000000-count-one": "¤0M",
              "1000000-count-other": "¤0M",
              "10000000-count-one": "¤00M",
              "10000000-count-other": "¤00M",
              "100000000-count-one": "¤000M",
              "100000000-count-other": "¤000M",
              "1000000000-count-one": "¤0B",
              "1000000000-count-other": "¤0B",
              "10000000000-count-one": "¤00B",
              "10000000000-count-other": "¤00B",
              "100000000000-count-one": "¤000B",
              "100000000000-count-other": "¤000B",
              "1000000000000-count-one": "¤0T",
              "1000000000000-count-other": "¤0T",
              "10000000000000-count-one": "¤00T",
              "10000000000000-count-other": "¤00T",
              "100000000000000-count-one": "¤000T",
              "100000000000000-count-other": "¤000T"
            }
          },
          "unitPattern-count-one": "{0} {1}",
          "unitPattern-count-other": "{0} {1}"
        },
        "miscPatterns-numberSystem-latn": {
          approximately: "~{0}",
          atLeast: "{0}+",
          atMost: "≤{0}",
          range: "{0}–{1}"
        },
        minimalPairs: {
          "pluralMinimalPairs-count-one": "{0} day",
          "pluralMinimalPairs-count-other": "{0} days",
          few: "Take the {0}rd right.",
          one: "Take the {0}st right.",
          other: "Take the {0}th right.",
          two: "Take the {0}nd right."
        }
      }
    },
    he: {
      identity: {
        version: {
          _number: "$Revision: 14394 $",
          _cldrVersion: "34"
        },
        language: "he"
      },
      dates: {
        calendars: {
          gregorian: {
            months: {
              format: {
                abbreviated: {
                  "1": "ינו׳",
                  "2": "פבר׳",
                  "3": "מרץ",
                  "4": "אפר׳",
                  "5": "מאי",
                  "6": "יוני",
                  "7": "יולי",
                  "8": "אוג׳",
                  "9": "ספט׳",
                  "10": "אוק׳",
                  "11": "נוב׳",
                  "12": "דצמ׳"
                },
                narrow: {
                  "1": "1",
                  "2": "2",
                  "3": "3",
                  "4": "4",
                  "5": "5",
                  "6": "6",
                  "7": "7",
                  "8": "8",
                  "9": "9",
                  "10": "10",
                  "11": "11",
                  "12": "12"
                },
                wide: {
                  "1": "ינואר",
                  "2": "פברואר",
                  "3": "מרץ",
                  "4": "אפריל",
                  "5": "מאי",
                  "6": "יוני",
                  "7": "יולי",
                  "8": "אוגוסט",
                  "9": "ספטמבר",
                  "10": "אוקטובר",
                  "11": "נובמבר",
                  "12": "דצמבר"
                }
              },
              "stand-alone": {
                abbreviated: {
                  "1": "ינו׳",
                  "2": "פבר׳",
                  "3": "מרץ",
                  "4": "אפר׳",
                  "5": "מאי",
                  "6": "יוני",
                  "7": "יולי",
                  "8": "אוג׳",
                  "9": "ספט׳",
                  "10": "אוק׳",
                  "11": "נוב׳",
                  "12": "דצמ׳"
                },
                narrow: {
                  "1": "1",
                  "2": "2",
                  "3": "3",
                  "4": "4",
                  "5": "5",
                  "6": "6",
                  "7": "7",
                  "8": "8",
                  "9": "9",
                  "10": "10",
                  "11": "11",
                  "12": "12"
                },
                wide: {
                  "1": "ינואר",
                  "2": "פברואר",
                  "3": "מרץ",
                  "4": "אפריל",
                  "5": "מאי",
                  "6": "יוני",
                  "7": "יולי",
                  "8": "אוגוסט",
                  "9": "ספטמבר",
                  "10": "אוקטובר",
                  "11": "נובמבר",
                  "12": "דצמבר"
                }
              }
            },
            days: {
              format: {
                abbreviated: {
                  sun: "יום א׳",
                  mon: "יום ב׳",
                  tue: "יום ג׳",
                  wed: "יום ד׳",
                  thu: "יום ה׳",
                  fri: "יום ו׳",
                  sat: "שבת"
                },
                narrow: {
                  sun: "א׳",
                  mon: "ב׳",
                  tue: "ג׳",
                  wed: "ד׳",
                  thu: "ה׳",
                  fri: "ו׳",
                  sat: "ש׳"
                },
                short: {
                  sun: "א׳",
                  mon: "ב׳",
                  tue: "ג׳",
                  wed: "ד׳",
                  thu: "ה׳",
                  fri: "ו׳",
                  sat: "ש׳"
                },
                wide: {
                  sun: "יום ראשון",
                  mon: "יום שני",
                  tue: "יום שלישי",
                  wed: "יום רביעי",
                  thu: "יום חמישי",
                  fri: "יום שישי",
                  sat: "יום שבת"
                }
              },
              "stand-alone": {
                abbreviated: {
                  sun: "יום א׳",
                  mon: "יום ב׳",
                  tue: "יום ג׳",
                  wed: "יום ד׳",
                  thu: "יום ה׳",
                  fri: "יום ו׳",
                  sat: "שבת"
                },
                narrow: {
                  sun: "א׳",
                  mon: "ב׳",
                  tue: "ג׳",
                  wed: "ד׳",
                  thu: "ה׳",
                  fri: "ו׳",
                  sat: "ש׳"
                },
                short: {
                  sun: "א׳",
                  mon: "ב׳",
                  tue: "ג׳",
                  wed: "ד׳",
                  thu: "ה׳",
                  fri: "ו׳",
                  sat: "ש׳"
                },
                wide: {
                  sun: "יום ראשון",
                  mon: "יום שני",
                  tue: "יום שלישי",
                  wed: "יום רביעי",
                  thu: "יום חמישי",
                  fri: "יום שישי",
                  sat: "יום שבת"
                }
              }
            },
            quarters: {
              format: {
                abbreviated: {
                  "1": "Q1",
                  "2": "Q2",
                  "3": "Q3",
                  "4": "Q4"
                },
                narrow: {
                  "1": "1",
                  "2": "2",
                  "3": "3",
                  "4": "4"
                },
                wide: {
                  "1": "רבעון 1",
                  "2": "רבעון 2",
                  "3": "רבעון 3",
                  "4": "רבעון 4"
                }
              },
              "stand-alone": {
                abbreviated: {
                  "1": "Q1",
                  "2": "Q2",
                  "3": "Q3",
                  "4": "Q4"
                },
                narrow: {
                  "1": "1",
                  "2": "2",
                  "3": "3",
                  "4": "4"
                },
                wide: {
                  "1": "רבעון 1",
                  "2": "רבעון 2",
                  "3": "רבעון 3",
                  "4": "רבעון 4"
                }
              }
            },
            dayPeriods: {
              format: {
                abbreviated: {
                  midnight: "חצות",
                  am: "לפנה״צ",
                  pm: "אחה״צ",
                  morning1: "בוקר",
                  afternoon1: "צהריים",
                  afternoon2: "אחר הצהריים",
                  evening1: "ערב",
                  night1: "לילה",
                  night2: "לפנות בוקר"
                },
                narrow: {
                  midnight: "חצות",
                  am: "לפנה״צ",
                  pm: "אחה״צ",
                  morning1: "בבוקר",
                  afternoon1: "בצהריים",
                  afternoon2: "אחה״צ",
                  evening1: "בערב",
                  night1: "בלילה",
                  night2: "לפנות בוקר"
                },
                wide: {
                  midnight: "חצות",
                  am: "לפנה״צ",
                  pm: "אחה״צ",
                  morning1: "בבוקר",
                  afternoon1: "בצהריים",
                  afternoon2: "אחר הצהריים",
                  evening1: "בערב",
                  night1: "בלילה",
                  night2: "לפנות בוקר"
                }
              },
              "stand-alone": {
                abbreviated: {
                  midnight: "חצות",
                  am: "AM",
                  pm: "PM",
                  morning1: "בוקר",
                  afternoon1: "צהריים",
                  afternoon2: "אחה״צ",
                  evening1: "ערב",
                  night1: "לילה",
                  night2: "לפנות בוקר"
                },
                narrow: {
                  midnight: "חצות",
                  am: "לפנה״צ",
                  pm: "אחה״צ",
                  morning1: "בוקר",
                  afternoon1: "צהריים",
                  afternoon2: "אחה״צ",
                  evening1: "ערב",
                  night1: "לילה",
                  night2: "לפנות בוקר"
                },
                wide: {
                  midnight: "חצות",
                  am: "AM",
                  pm: "PM",
                  morning1: "בוקר",
                  afternoon1: "צהריים",
                  afternoon2: "אחר הצהריים",
                  evening1: "ערב",
                  night1: "לילה",
                  night2: "לפנות בוקר"
                }
              }
            },
            eras: {
              eraNames: {
                "0": "לפני הספירה",
                "0-alt-variant": "לפנה״ס",
                "1": "לספירה",
                "1-alt-variant": "CE"
              },
              eraAbbr: {
                "0": "לפנה״ס",
                "0-alt-variant": "BCE",
                "1": "לספירה",
                "1-alt-variant": "CE"
              },
              eraNarrow: {
                "0": "לפנה״ס",
                "0-alt-variant": "BCE",
                "1": "לספירה",
                "1-alt-variant": "CE"
              }
            },
            dateFormats: {
              full: "EEEE, d בMMMM y",
              long: "d בMMMM y",
              medium: "d בMMM y",
              short: "d.M.y"
            },
            timeFormats: {
              full: "H:mm:ss zzzz",
              long: "H:mm:ss z",
              medium: "H:mm:ss",
              short: "H:mm"
            },
            dateTimeFormats: {
              full: "{1} בשעה {0}",
              long: "{1} בשעה {0}",
              medium: "{1}, {0}",
              short: "{1}, {0}",
              availableFormats: {
                Bh: "h B",
                Bhm: "h:mm B",
                Bhms: "h:mm:ss B",
                d: "d",
                E: "ccc",
                EBhm: "E h:mm B",
                EBhms: "E h:mm:ss B",
                Ed: "E ה-d",
                Ehm: "E h:mm a",
                EHm: "E H:mm",
                Ehms: "E h:mm:ss a",
                EHms: "E H:mm:ss",
                Gy: "y G",
                GyMMM: "MMM y G",
                GyMMMd: "d בMMM y G",
                GyMMMEd: "E, d בMMM y G",
                h: "‏h a",
                H: "H",
                hm: "h:mm a",
                Hm: "H:mm",
                hms: "h:mm:ss a",
                Hms: "H:mm:ss",
                hmsv: "h:mm:ss a v",
                Hmsv: "HH:mm:ss v",
                hmv: "h:mm a v",
                Hmv: "HH:mm v",
                M: "L",
                Md: "d.M",
                MEd: "E, d.M",
                MMM: "LLL",
                MMMd: "d בMMM",
                MMMEd: "E, d בMMM",
                MMMMd: "d בMMMM",
                "MMMMW-count-one": "שבוע W בMMM",
                "MMMMW-count-two": "שבוע W בMMM",
                "MMMMW-count-many": "שבוע W בMMM",
                "MMMMW-count-other": "שבוע W בMMM",
                ms: "mm:ss",
                y: "y",
                yM: "M.y",
                yMd: "d.M.y",
                yMEd: "E, d.M.y",
                yMM: "M.y",
                yMMM: "MMM y",
                yMMMd: "d בMMM y",
                yMMMEd: "E, d בMMM y",
                yMMMM: "MMMM y",
                yQQQ: "QQQ y",
                yQQQQ: "QQQQ y",
                "yw-count-one": "שבוע w בשנת Y",
                "yw-count-two": "שבוע w בשנת Y",
                "yw-count-many": "שבוע w בשנת Y",
                "yw-count-other": "שבוע w בשנת Y"
              },
              appendItems: {
                Day: "{0} ({2}: {1})",
                "Day-Of-Week": "{0} {1}",
                Era: "{1} {0}",
                Hour: "{0} ({2}: {1})",
                Minute: "{0} ({2}: {1})",
                Month: "{0} ({2}: {1})",
                Quarter: "{0} ({2}: {1})",
                Second: "{0} ({2}: {1})",
                Timezone: "{0} {1}",
                Week: "{0} ({2}: {1})",
                Year: "{1} {0}"
              },
              intervalFormats: {
                intervalFormatFallback: "{0} – {1}",
                d: {
                  d: "d–d"
                },
                Gy: {
                  G: "G y – G y",
                  y: "G y–y"
                },
                GyM: {
                  G: "GGGGG y-MM – GGGGG y-MM",
                  M: "GGGGG y-MM – y-MM",
                  y: "GGGGG y-MM – y-MM"
                },
                GyMd: {
                  d: "GGGGG y-MM-dd – y-MM-dd",
                  G: "GGGGG y-MM-dd – GGGGG y-MM-dd",
                  M: "GGGGG y-MM-dd – y-MM-dd",
                  y: "GGGGG y-MM-dd – y-MM-dd"
                },
                GyMEd: {
                  d: "GGGGG y-MM-dd, E – y-MM-dd, E",
                  G: "GGGGG y-MM-dd, E – GGGGG y-MM-dd, E",
                  M: "GGGGG y-MM-dd, E – y-MM-dd, E",
                  y: "GGGGG y-MM-dd, E – y-MM-dd, E"
                },
                GyMMM: {
                  G: "G y MMM – G y MMM",
                  M: "G y MMM–MMM",
                  y: "G y MMM – y MMM"
                },
                GyMMMd: {
                  d: "G y MMM d–d",
                  G: "G y MMM d – G y MMM d",
                  M: "G y MMM d – MMM d",
                  y: "G y MMM d – y MMM d"
                },
                GyMMMEd: {
                  d: "G y MMM d, E – MMM d, E",
                  G: "G y MMM d, E – G y MMM d, E",
                  M: "G y MMM d, E – MMM d, E",
                  y: "G y MMM d, E – y MMM d, E"
                },
                h: {
                  a: "h a – h a",
                  h: "h–h a"
                },
                H: {
                  H: "H–H"
                },
                hm: {
                  a: "h:mm a – h:mm a",
                  h: "h:mm–h:mm a",
                  m: "h:mm–h:mm a"
                },
                Hm: {
                  H: "H:mm–H:mm",
                  m: "H:mm–H:mm"
                },
                hmv: {
                  a: "h:mm a – h:mm a v",
                  h: "h:mm–h:mm a v",
                  m: "h:mm–h:mm a v"
                },
                Hmv: {
                  H: "H:mm–H:mm v",
                  m: "H:mm–H:mm v"
                },
                hv: {
                  a: "h a – h a v",
                  h: "h–h a v"
                },
                Hv: {
                  H: "H–H v"
                },
                M: {
                  M: "M–M"
                },
                Md: {
                  d: "d.M–d.M",
                  M: "d.M–d.M"
                },
                MEd: {
                  d: "EEEE d.M–EEEE d.M",
                  M: "EEEE d.M – EEEE d.M"
                },
                MMM: {
                  M: "MMM–MMM"
                },
                MMMd: {
                  d: "d–d בMMM",
                  M: "d בMMM–d בMMM"
                },
                MMMEd: {
                  d: "EEEE, d בMMM – EEEE, d בMMM",
                  M: "EEEE, d בMMM – EEEE, d בMMM"
                },
                MMMM: {
                  M: "LLLL–LLLL"
                },
                y: {
                  y: "y–y"
                },
                yM: {
                  M: "M.y–M.y",
                  y: "M.y‏–M.y"
                },
                yMd: {
                  d: "dd.M.y – dd.M.y",
                  M: "d.M.y – d.M.y",
                  y: "d.M.y – d.M.y"
                },
                yMEd: {
                  d: "EEEE d.M.y – EEEE d.M.y",
                  M: "EEEE d.M.y – EEEE d.M.y",
                  y: "EEEE d.M.y – EEEE d.M.y"
                },
                yMMM: {
                  M: "MMM–MMM y",
                  y: "MMM y – MMM y"
                },
                yMMMd: {
                  d: "d–d בMMM y",
                  M: "d MMM – d MMM y",
                  y: "d MMM y – d MMM y"
                },
                yMMMEd: {
                  d: "EEEE d MMM – EEEE d MMM y",
                  M: "EEEE d MMM – EEEE d MMM y",
                  y: "EEEE d MMM y – EEEE d MMM y"
                },
                yMMMM: {
                  M: "MMMM–MMMM y",
                  y: "MMMM y–MMMM y"
                }
              }
            }
          }
        }
      },
      numbers: {
        defaultNumberingSystem: "latn",
        otherNumberingSystems: {
          native: "latn",
          traditional: "hebr"
        },
        minimumGroupingDigits: "1",
        "symbols-numberSystem-latn": {
          decimal: ".",
          group: ",",
          list: ";",
          percentSign: "%",
          plusSign: "‎+",
          minusSign: "‎-",
          exponential: "E",
          superscriptingExponent: "×",
          perMille: "‰",
          infinity: "∞",
          nan: "NaN",
          timeSeparator: ":"
        },
        "decimalFormats-numberSystem-latn": {
          standard: "#,##0.###",
          long: {
            decimalFormat: {
              "1000-count-one": "‏0 אלף",
              "1000-count-two": "‏0 אלף",
              "1000-count-many": "‏0 אלף",
              "1000-count-other": "‏0 אלף",
              "10000-count-one": "‏00 אלף",
              "10000-count-two": "‏00 אלף",
              "10000-count-many": "‏00 אלף",
              "10000-count-other": "‏00 אלף",
              "100000-count-one": "‏000 אלף",
              "100000-count-two": "‏000 אלף",
              "100000-count-many": "‏000 אלף",
              "100000-count-other": "‏000 אלף",
              "1000000-count-one": "‏0 מיליון",
              "1000000-count-two": "‏0 מיליון",
              "1000000-count-many": "‏0 מיליון",
              "1000000-count-other": "‏0 מיליון",
              "10000000-count-one": "‏00 מיליון",
              "10000000-count-two": "‏00 מיליון",
              "10000000-count-many": "‏00 מיליון",
              "10000000-count-other": "‏00 מיליון",
              "100000000-count-one": "‏000 מיליון",
              "100000000-count-two": "‏000 מיליון",
              "100000000-count-many": "‏000 מיליון",
              "100000000-count-other": "‏000 מיליון",
              "1000000000-count-one": "‏0 מיליארד",
              "1000000000-count-two": "‏0 מיליארד",
              "1000000000-count-many": "‏0 מיליארד",
              "1000000000-count-other": "‏0 מיליארד",
              "10000000000-count-one": "‏00 מיליארד",
              "10000000000-count-two": "‏00 מיליארד",
              "10000000000-count-many": "‏00 מיליארד",
              "10000000000-count-other": "‏00 מיליארד",
              "100000000000-count-one": "‏000 מיליארד",
              "100000000000-count-two": "‏000 מיליארד",
              "100000000000-count-many": "‏000 מיליארד",
              "100000000000-count-other": "‏000 מיליארד",
              "1000000000000-count-one": "‏0 טריליון",
              "1000000000000-count-two": "‏0 טריליון",
              "1000000000000-count-many": "‏0 טריליון",
              "1000000000000-count-other": "‏0 טריליון",
              "10000000000000-count-one": "‏00 טריליון",
              "10000000000000-count-two": "‏00 טריליון",
              "10000000000000-count-many": "‏00 טריליון",
              "10000000000000-count-other": "‏00 טריליון",
              "100000000000000-count-one": "‏000 טריליון",
              "100000000000000-count-two": "‏000 טריליון",
              "100000000000000-count-many": "‏000 טריליון",
              "100000000000000-count-other": "‏000 טריליון"
            }
          },
          short: {
            decimalFormat: {
              "1000-count-one": "0K",
              "1000-count-two": "0K",
              "1000-count-many": "0K",
              "1000-count-other": "0K",
              "10000-count-one": "00K",
              "10000-count-two": "00K",
              "10000-count-many": "00K",
              "10000-count-other": "00K",
              "100000-count-one": "000K",
              "100000-count-two": "000K",
              "100000-count-many": "000K",
              "100000-count-other": "000K",
              "1000000-count-one": "0M",
              "1000000-count-two": "0M",
              "1000000-count-many": "0M",
              "1000000-count-other": "0M",
              "10000000-count-one": "00M",
              "10000000-count-two": "00M",
              "10000000-count-many": "00M",
              "10000000-count-other": "00M",
              "100000000-count-one": "000M",
              "100000000-count-two": "000M",
              "100000000-count-many": "000M",
              "100000000-count-other": "000M",
              "1000000000-count-one": "0B",
              "1000000000-count-two": "0B",
              "1000000000-count-many": "0B",
              "1000000000-count-other": "0B",
              "10000000000-count-one": "00B",
              "10000000000-count-two": "00B",
              "10000000000-count-many": "00B",
              "10000000000-count-other": "00B",
              "100000000000-count-one": "000B",
              "100000000000-count-two": "000B",
              "100000000000-count-many": "000B",
              "100000000000-count-other": "000B",
              "1000000000000-count-one": "0T",
              "1000000000000-count-two": "0T",
              "1000000000000-count-many": "0T",
              "1000000000000-count-other": "0T",
              "10000000000000-count-one": "00T",
              "10000000000000-count-two": "00T",
              "10000000000000-count-many": "00T",
              "10000000000000-count-other": "00T",
              "100000000000000-count-one": "000T",
              "100000000000000-count-two": "000T",
              "100000000000000-count-many": "000T",
              "100000000000000-count-other": "000T"
            }
          }
        },
        "scientificFormats-numberSystem-latn": {
          standard: "#E0"
        },
        "percentFormats-numberSystem-latn": {
          standard: "#,##0%"
        },
        "currencyFormats-numberSystem-latn": {
          currencySpacing: {
            beforeCurrency: {
              currencyMatch: "[:^S:]",
              surroundingMatch: "[:digit:]",
              insertBetween: " "
            },
            afterCurrency: {
              currencyMatch: "[:^S:]",
              surroundingMatch: "[:digit:]",
              insertBetween: " "
            }
          },
          standard: "‏#,##0.00 ¤;‏-#,##0.00 ¤",
          accounting: "#,##0.00 ¤",
          short: {
            standard: {
              "1000-count-one": "¤ 0K",
              "1000-count-two": "¤ 0K",
              "1000-count-many": "¤0K",
              "1000-count-other": "¤ 0K",
              "10000-count-one": "¤00K",
              "10000-count-two": "¤00K",
              "10000-count-many": "¤00K",
              "10000-count-other": "¤ 00K",
              "100000-count-one": "¤000K",
              "100000-count-two": "¤000K",
              "100000-count-many": "¤000K",
              "100000-count-other": "¤000K",
              "1000000-count-one": "¤0M",
              "1000000-count-two": "¤0M",
              "1000000-count-many": "¤0M",
              "1000000-count-other": "¤0M",
              "10000000-count-one": "¤00M",
              "10000000-count-two": "¤00M",
              "10000000-count-many": "¤00M",
              "10000000-count-other": "¤00M",
              "100000000-count-one": "¤000M",
              "100000000-count-two": "¤000M",
              "100000000-count-many": "¤000M",
              "100000000-count-other": "¤000M",
              "1000000000-count-one": "¤0B",
              "1000000000-count-two": "¤0B",
              "1000000000-count-many": "¤0B",
              "1000000000-count-other": "¤0B",
              "10000000000-count-one": "¤00B",
              "10000000000-count-two": "¤00B",
              "10000000000-count-many": "¤00B",
              "10000000000-count-other": "¤00B",
              "100000000000-count-one": "¤000B",
              "100000000000-count-two": "¤000B",
              "100000000000-count-many": "¤000B",
              "100000000000-count-other": "¤000B",
              "1000000000000-count-one": "¤0T",
              "1000000000000-count-two": "¤0T",
              "1000000000000-count-many": "¤0T",
              "1000000000000-count-other": "¤0T",
              "10000000000000-count-one": "¤00T",
              "10000000000000-count-two": "¤00T",
              "10000000000000-count-many": "¤00T",
              "10000000000000-count-other": "¤00T",
              "100000000000000-count-one": "¤000T",
              "100000000000000-count-two": "¤000T",
              "100000000000000-count-many": "¤000T",
              "100000000000000-count-other": "¤000T"
            }
          },
          "unitPattern-count-one": "{0} {1}",
          "unitPattern-count-two": "{0} {1}",
          "unitPattern-count-many": "{0} {1}",
          "unitPattern-count-other": "{0} {1}"
        },
        "miscPatterns-numberSystem-latn": {
          approximately: "~{0}",
          atLeast: "≥{0}+",
          atMost: "≤{0}",
          range: "{0}–{1}"
        },
        minimalPairs: {
          "pluralMinimalPairs-count-one": "שנה",
          "pluralMinimalPairs-count-two": "שנתיים",
          "pluralMinimalPairs-count-many": "{0} שנה",
          "pluralMinimalPairs-count-other": "{0} שנים",
          other: "פנה ימינה בפנייה ה-{0}"
        }
      }
    }
  },
  supplemental: {
    likelySubtags: {
      he: "he-Hebr-IL",
      en: "en-Latn-US"
    },
    timeDate: {
      IL: {
        _allowed: "H hB",
        _preferred: "H"
      },
      US: {
        _allowed: "h hb H hB",
        _preferred: "h"
      }
    },
    weekData: {
      minDays: {
        "001": "1",
        US: "1"
      },
      firstDay: {
        "001": "mon",
        IL: "sun",
        US: "sun"
      },
      weekendStart: {
        "001": "sat",
        IL: "fri"
      },
      weekendEnd: {
        "001": "sun",
        IL: "sat"
      },
      "en bn ja ka": {
        _ordering: "weekOfDate weekOfMonth"
      },
      und: {
        _ordering: "weekOfYear"
      }
    }
  }
};
